import {Link} from "react-router-dom";
import Loader2 from "../../Components/Loader2";
import {useGetCategoriesQuery} from "../../RTK/Slices/Slices/apiSliceMeat";

function Categories() {
    const {data: Categories, isErrorBrands, isLoadingBrands} = useGetCategoriesQuery();
    const dataCategories = Categories?.data ?? [];

    if (isLoadingBrands) return <Loader2 />;
    if (isErrorBrands) return null;

    return (
        <div className="bg-gray-100">
            <div className="flex items-center justify-center w-full !pt-5 md:!pt-10 container">
                <h1 className="text-mainColor text-lg font-bold md:text-4xl"></h1>
            </div>
            <div className="container py-5 md:py-10">
                <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7 gap-2 md:gap-6">
                    {dataCategories.map((Categorie) => (
                        <Link
                            key={Categorie?.category_id}
                            to={`ProductsCategorie/${Categorie?.category_id}`}
                            className="group"
                        >
                            <div className="transition-all duration-300 transform hover:-translate-y-1 overflow-hidden">
                                <div className="p-4 md:p-6">
                                    <div className="flex justify-center items-center overflow-hidden mb-3 md:mb-4">
                                        <img
                                            src={Categorie?.image_url}
                                            alt={Categorie?.category_name}
                                            className="w-full h-full rounded-lg object-contain"
                                            loading="lazy"
                                        />
                                    </div>
                                    <h3 className="text-center text-sm md:text-base font-medium text-gray-800">
                                        {Categorie?.category_name}
                                    </h3>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Categories;
